import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}`; 

export const getDashboardDataQuery = async () => {
    const customHeaders = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAuthToken()}`,
    };
    const response = await axiosInstance.get(
        `${API_URL}/dashboard`,
        { headers: customHeaders }
    );
    return response.data;
};